<template>
  <div class="add-from-catalog-detail">
    <div class="product-container">
      <div class="image-container">
        <AllCatalogImages :images="product.content.images" />
      </div>
      <div class="product-info">
        <span
          class="product-title"
          @click="showInTrendyol"
        >
          {{ product.content.title }}
        </span>
        <ul class="product-attrs">
          <li>
            Barkod:
            <span>{{ selectedBarcode }}</span>
          </li>
          <li>
            Kategori:
            <span>{{ product.content.categoryName }}</span>
          </li>
          <li>
            Marka:
            <span>{{ product.content.commonBrand ? `Genel Markalar - ${product.content.brandName}` :
              product.content.brandName }}</span>
          </li>
          <li>
            Renk:
            <span>{{ color }}</span>
          </li>
          <li>
            KDV:
            <span>%{{ product.content.vatRate }}</span>
          </li>
        </ul>
        <ul class="product-prices">
          <li>
            <div>
              <img
                class="form-search-icon"
                :src="`${$root.cdnUrl}assets/buybox_icon.svg`"
              >
              Buybox Fiyatı:
            </div>
            <span>{{ buyBoxPrice || '---' }}₺ </span>
          </li>
        </ul>
      </div>
      <div class="detail-inputs">
        <div>
          <span>Beden</span>
          <GSelect
            v-model="selectedSize"
            :options="sizeOptions"
          />
        </div>
        <GAlert
          v-if="isExist"
          variant="warning"
          :show-icon="false"
        >
          <img :src="`${$root.cdnUrl}assets/warning-icon-filled-with-orange.svg`">
          {{ selectedBarcode }} barkodlu ürün, ürün listenizde mevcuttur.
        </GAlert>
        <div v-if="!isExist">
          <span>Satıcı Stok Kodu</span>
          <GInput v-model="product.content.stockCode" />
        </div>
        <div v-if="!isExist">
          <span>Stok Miktarı</span>
          <GInputQuantity
            v-model="product.content.quantity"
            name="fromCatalog_quantity"
            data-cy="fromCatalog_quantity"
            v-validate="{ configMax: true, required: true }"
            data-vv-validate-on="change|input"
            data-vv-as="Stok Miktarı"
            autocomplete="off"
            :error="errors.has('fromCatalog_quantity')"
          />
          <div class="invalid-feedback">
            {{ errors.first('fromCatalog_quantity') }}
          </div>
        </div>
        <div
          class="last-item"
          v-if="!isExist"
        >
          <span>Trendyol Satış Fiyatı</span>
          <GInputPrice
            v-model="product.content.salePrice"
            name="fromCatalog_salePrice"
            data-cy="fromCatalog_salePrice"
            v-validate="{ required: true, maxSalePrice: product.content.salePrice }"
            data-vv-validate-on="change|input"
            data-vv-as="Trendyol Satış Fiyatı"
            :error="errors.has(`fromCatalog_salePrice`)"
          />
          <div class="invalid-feedback">
            {{ errors.first('fromCatalog_salePrice') }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <GButton
        :class="{ disabled: EXCLUDE_CATEGORY_IDS.includes(product.content.categoryId) || EXCLUDE_BRAND_IDS.includes(product.content.brandId) || product.content.language !== 'tr' }"
        :disabled="errors.any() || isExist || EXCLUDE_CATEGORY_IDS.includes(product.content.categoryId) || EXCLUDE_BRAND_IDS.includes(product.content.brandId) || product.content.language !== 'tr'"
        @click="createProductBarcode"
      >
        Onayla ve Satışa Aç
      </GButton>
    </div>
  </div>
</template>
<script>
import GSelect from '@trendyol-js/grace/core/GSelect';
import GButton from '@trendyol-js/grace/core/GButton';
import GInput from '@trendyol-js/grace/core/GInput';
import GAlert from '@trendyol-js/grace/core/GAlert';
import GInputPrice from '@trendyol-js/grace/core/GInputPrice';
import GInputQuantity from '@/components/GInputQuantity';
import AllCatalogImages from '@/pages/AddFromCatalog/Components/AllCatalogImages';
import service from '@/services/singleProduct';
import messageHandler from '@/utils/message';
import routerPush from '@/mixins/routerPush';

const EXCLUDE_CATEGORY_IDS = [5541, 4984, 5623];
const EXCLUDE_BRAND_IDS = [2078308, 1811239, 2637342];

export default {
  name: 'CatalogDetail',
  components: { AllCatalogImages, GInputQuantity, GInput, GInputPrice, GSelect, GButton, GAlert },
  mixins: [routerPush],
  data () {
    return {
      product: {},
      productContentId: 0,
      color: '',
      sizeOptions: [],
      selectedSize: '',
      selectedBarcode: '',
      createdProduct: '',
      isExist: '',
      params: {
        page: 0,
        pageSize: 99,
      },
      isLoading: false,
      buyBoxPrice: 0,
      EXCLUDE_BRAND_IDS,
      EXCLUDE_CATEGORY_IDS,
    };
  },
  methods: {
    async setPage () {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      await this.getProducts();
      this.findColor();
      if (params.barcode) {
        this.selectedBarcode = params.barcode;
        this.setBarcodeSearchSizeOptions();
      } else {
        this.findSize();
      }
    },
    async getProducts () {
      let result = {};
      const contentId = this.$route.params;
      const response = await service.getProductViaContentId(contentId.contentId, this.params);
      const contentGroup = this._createContentGroupFromProductsResponse(response.content);
      const contentResponse = this._createContentResponse(contentGroup);
      result = contentResponse[0];
      this.product = result;
    },
    async getBuyBoxPrice () {
      let response = {};
      const selectedVariant = this.product.variants.find(
        (variant) => variant.barcode === this.selectedBarcode,
      );
      this.isLoading = true;
      const contentIdNumber = parseInt(this.$route.params.contentId);
      if (selectedVariant.variantId) {
        response = await service.getBuyboxContents(
          {
            variantId: selectedVariant.variantId,
            culture: 'tr-TR',
            contentIds: [contentIdNumber],
          },
        );
      } else {
        response = await service.getBuyboxContents(
          {
            variantId: this.product.content.variantId,
            culture: 'tr-TR',
            contentIds: [contentIdNumber],
          },
        );
      }
      this.buyBoxPrice = response?.contents?.[0]?.listings?.[0]?.buyboxWinnerPrice;
      this.isLoading = false;
    },
    _createContentGroupFromProductsResponse (items) {
      let contentGroup = {};
      contentGroup = items.reduce((r, a) => {
        r[a.pimContentId] = [...r[a.pimContentId] || [], a];
        return r;
      }, {});
      return contentGroup;
    },
    _createContentResponse (contentGroup) {
      const contentResponse = [];
      // eslint-disable-next-line no-unused-vars
      for (const [_, value] of Object.entries(contentGroup)) {
        contentResponse.push({
          variants: this._getVarianterFromProduct(value),
          content: this._getContentFromProduct(value),
        });
      }

      return contentResponse;
    },
    _getVarianterFromProduct (contents) {
      return contents.map(content => ({
        barcode: content.barcode,
        attributes: content.productAttributes ? content.productAttributes.filter(attr => attr.varianter === true) : [],
        exist: content.exist,
        variantId: content.variantId,
      }));
    },
    _getContentFromProduct (contents) {
      return contents.map(content => ({
        attributes:
          content.productAttributes ? content.productAttributes
            .filter(attr => attr.varianter === false)
            .map(attr => ({ ...attr, valueName: attr.customValue }))
            : [],
        listPrice: 0,
        salePrice: 0,
        quantity: 0,
        ...content,
      }))[0];
    },
    findColor () {
      this.product.content.attributes.forEach(attr => {
        if (attr.id === 47) {
          this.color = attr.valueName;
        }
      });
    },
    showInTrendyol () {
      const a = document.createElement('a');
      a.href = this.product.content.productUrl;
      a.target = '_blank';
      a.click();
    },
    hasException () {
      const validationResult = this.$validator._base.validateAll();
      if (!validationResult) {
        return true;
      }
      return false;
    },
    async getBadgePricesByVariantId (variantId) {
      const response = await service.getBadgePricesByVariantId(variantId);
      return response;
    },
    async createProductBarcode () {
      if (this.hasException()) {
        return;
      }
      const item = this.product.content;
      const salePrice = parseFloat(item.salePrice);
      const data = {};
      data.barcode = this.selectedBarcode;
      data.title = item.title;
      data.productMainId = item.productMainId;
      data.brandId = item.brandId;
      data.categoryId = item.categoryId;
      data.quantity = parseInt(item.quantity, 10);
      data.stockCode = item.stockCode;
      data.dimensionalWeight = 0;
      data.description = (item.description === '' ? item.title : item.description);
      data.currencyType = 'TRY';
      data.listPrice = salePrice;
      data.salePrice = salePrice;
      data.vatRate = item.vatRate;
      data.cargoCompanyId = item.cargoCompanyId;
      data.returningAddressId = item.returningAddressId;
      data.businessUnitId = item?.businessUnit?.id;
      data.images = item.images ? item.images.map(image => ({
        url: image.originalImageUrl.replace(/_org_icon/gi, ''),
      })) : null;

      this.createdProduct = Object.assign({}, data);

      data.attributes = item.attributes.map(attr => ({
        attributeId: attr.id,
        attributeValueId: attr.valueId ? attr.valueId : null,
        customAttributeValue: !attr.valueId ? attr.customValue : null,
      }));
      const { minPrice, maxPrice } = await this.getBadgePricesByVariantId(this.product?.content?.variantId);
      await service.createProduct(data);
      if (data.salePrice > maxPrice) {
        messageHandler.warning('Talebiniz alınmıştır. Ürün fiyatı, bu ürüne özgü hesapladığımız maksimum fiyattan yüksektir. Ürününüz bu sebepten kitlenebilir.');
      } else if (data.salePrice < minPrice) {
        messageHandler.warning('Talebiniz alınmıştır. Ürün fiyatı, bu ürüne özgü hesapladığımız minimum fiyattan düşüktür. Ürününüz bu sebepten kitlenebilir.');
      } else {
        messageHandler.success('Talebiniz başarıyla alınmıştır.');
      }
      setTimeout(() => {
        this.routerPush('Search');
      }, 2000);
    },
    setBarcodeSearchSizeOptions () {
      this.product.variants.forEach(variant => {
        if (variant.attributes?.[0].name === 'Beden' && variant.barcode === this.selectedBarcode) {
          this.sizeOptions.push({
            text: variant.attributes[0].valueName,
            value: variant.attributes[0].valueName,
          });
        } else if (variant?.attributes?.length === 0) {
          this.sizeOptions.push({
            text: 'Tek Ebat',
            value: variant.barcode,
          });
        }
      });
      this.selectedSize = this.sizeOptions[0].text;
    },
    findSize () {
      this.product.variants.forEach(variant => {
        if (variant.attributes.length > 0 && variant.attributes?.[0].name === 'Beden') {
          this.sizeOptions.push({
            text: variant.attributes[0].valueName,
            value: variant.attributes[0].valueName,
          });
        } else if (variant?.attributes?.length === 0) {
          this.sizeOptions.push({
            text: 'Tek Ebat',
            value: variant.barcode,
          });
        }
      });
      this.selectedSize = this.sizeOptions[0].value;
    },
  },
  watch: {
    selectedSize () {
      this.product.variants.forEach(variant => {
        if (variant.attributes.length > 0 && variant.attributes[0].valueName === this.selectedSize) {
          this.selectedBarcode = variant.barcode;
          this.isExist = variant.exist;
        } else if (variant?.attributes?.length === 0) {
          this.selectedBarcode = variant.barcode;
          this.isExist = variant.exist;
        }
      });
      this.getBuyBoxPrice();
    },
  },
  created () {
    this.setPage();
  },
};
</script>
<style lang="scss" scoped>
.add-from-catalog-detail {
  .product-container {
    padding: 16px 12px;

    .image-container {
      margin-bottom: 16px;
      overflow-y: auto;

      ul {
        display: flex;
        gap: 5px;
        list-style-type: none;
        padding: 0;
        margin: 0;

        li img {
          border-radius: 6px;
        }
      }
    }

    .product-info {
      .product-title {
        text-decoration: underline !important;
      }

      ul {
        list-style-type: none;
        padding: 10px 0;
        margin: 0;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #95A1B5;
        border-bottom: 1px solid #DCDEE4;

        div {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
        }

        li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 3px;

          span {
            color: #273142;
          }
        }
      }

      .product-prices {
        display: flex;
        padding: 10px 0 0 0;

        li {
          width: 100%;
        }

        span {
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }

    .detail-inputs {
      padding-top: 20px;

      div {
        margin-bottom: 20px;

        span {
          font-weight: 500;
          font-size: 12px;
          line-height: 12px;
          color: #6E7787;
        }

        .invalid-feedback {
          color: #ff5043;
          font-size: 10px;
        }

        ::v-deep .g-input {
          .content {
            border: 1px solid #D5D9E1;
            border-radius: 6px;
          }
        }

        ::v-deep .g-select {
          .g-field-wrapper {
            .content {
              border: 1px solid #D5D9E1 !important;
              border-radius: 6px !important;

              .s-content {
                width: 100%;
                border: 1px solid #D5D9E1 !important;
                border-radius: 6px !important;
              }
            }
          }
        }
      }

      ::v-deep .g-alert {
        .content {
          display: flex;
          gap: 8px;
        }
      }
    }
  }

  .last-item {
    margin-bottom: 80px !important;
  }

  .footer {
    position: fixed;
    bottom: 0;
    height: 80px;
    width: 100%;
    padding: 16px;
    background: white;
    box-shadow: 0px -8px 15px rgba(39, 49, 66, 0.1);
    border-radius: 10px 10px 0 0;
    opacity: 1 !important;

    .g-button {
      width: 100%;
      height: 50px;
      border-radius: 6px;
      background: #F27A1A;
      color: white;

      &.disabled {
        background: var(--bg-grey-500);
        color: var(--light-grey-500);
        border-color: var(--bg-grey-500);
      }
    }
  }
}
</style>
